/* tslint:disable */
/* eslint-disable */
/**
 * Web IMD-CONNECT.PRO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Company } from '../models';
/**
 * InsurancesApi - axios parameter creator
 * @export
 */
export const InsurancesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all insuranceoffices
         * @param {number} [trashed] Get trashed items.
         * @param {number} [offset] How many items should be scipped. For example if you want to start at the third item, value should be 2.
         * @param {number} [size] How many items to return at one time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insuranceofficesGet: async (trashed?: number, offset?: number, size?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/insuranceoffices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required

            if (trashed !== undefined) {
                localVarQueryParameter['trashed'] = trashed;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new insurance
         * @param {Company} [company] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insuranceofficesPost: async (company?: Company, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/insuranceoffices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(company, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all insurances
         * @param {number} [trashed] Get trashed items.
         * @param {number} [offset] How many items should be scipped. For example if you want to start at the third item, value should be 2.
         * @param {number} [size] How many items to return at one time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insurancesGet: async (trashed?: number, offset?: number, size?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/insurances`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required

            if (trashed !== undefined) {
                localVarQueryParameter['trashed'] = trashed;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get a specific insurance
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insurancesIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('insurancesIdGet', 'id', id)
            const localVarPath = `/insurances/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a specific insurance
         * @param {number} id 
         * @param {Company} [company] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insurancesIdPut: async (id: number, company?: Company, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('insurancesIdPut', 'id', id)
            const localVarPath = `/insurances/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(company, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new insurance
         * @param {Company} [company] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insurancesPost: async (company?: Company, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/insurances`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(company, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InsurancesApi - functional programming interface
 * @export
 */
export const InsurancesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InsurancesApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all insuranceoffices
         * @param {number} [trashed] Get trashed items.
         * @param {number} [offset] How many items should be scipped. For example if you want to start at the third item, value should be 2.
         * @param {number} [size] How many items to return at one time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insuranceofficesGet(trashed?: number, offset?: number, size?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Company>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insuranceofficesGet(trashed, offset, size, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a new insurance
         * @param {Company} [company] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insuranceofficesPost(company?: Company, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Company>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insuranceofficesPost(company, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all insurances
         * @param {number} [trashed] Get trashed items.
         * @param {number} [offset] How many items should be scipped. For example if you want to start at the third item, value should be 2.
         * @param {number} [size] How many items to return at one time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insurancesGet(trashed?: number, offset?: number, size?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Company>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insurancesGet(trashed, offset, size, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get a specific insurance
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insurancesIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Company>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insurancesIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a specific insurance
         * @param {number} id 
         * @param {Company} [company] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insurancesIdPut(id: number, company?: Company, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Company>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insurancesIdPut(id, company, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a new insurance
         * @param {Company} [company] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insurancesPost(company?: Company, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Company>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insurancesPost(company, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * InsurancesApi - factory interface
 * @export
 */
export const InsurancesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InsurancesApiFp(configuration)
    return {
        /**
         * Get all insuranceoffices
         * @param {number} [trashed] Get trashed items.
         * @param {number} [offset] How many items should be scipped. For example if you want to start at the third item, value should be 2.
         * @param {number} [size] How many items to return at one time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insuranceofficesGet(trashed?: number, offset?: number, size?: number, options?: any): AxiosPromise<Array<Company>> {
            return localVarFp.insuranceofficesGet(trashed, offset, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new insurance
         * @param {Company} [company] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insuranceofficesPost(company?: Company, options?: any): AxiosPromise<Company> {
            return localVarFp.insuranceofficesPost(company, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all insurances
         * @param {number} [trashed] Get trashed items.
         * @param {number} [offset] How many items should be scipped. For example if you want to start at the third item, value should be 2.
         * @param {number} [size] How many items to return at one time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insurancesGet(trashed?: number, offset?: number, size?: number, options?: any): AxiosPromise<Array<Company>> {
            return localVarFp.insurancesGet(trashed, offset, size, options).then((request) => request(axios, basePath));
        },
        /**
         * get a specific insurance
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insurancesIdGet(id: number, options?: any): AxiosPromise<Company> {
            return localVarFp.insurancesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a specific insurance
         * @param {number} id 
         * @param {Company} [company] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insurancesIdPut(id: number, company?: Company, options?: any): AxiosPromise<Company> {
            return localVarFp.insurancesIdPut(id, company, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new insurance
         * @param {Company} [company] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insurancesPost(company?: Company, options?: any): AxiosPromise<Company> {
            return localVarFp.insurancesPost(company, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InsurancesApi - object-oriented interface
 * @export
 * @class InsurancesApi
 * @extends {BaseAPI}
 */
export class InsurancesApi extends BaseAPI {
    /**
     * Get all insuranceoffices
     * @param {number} [trashed] Get trashed items.
     * @param {number} [offset] How many items should be scipped. For example if you want to start at the third item, value should be 2.
     * @param {number} [size] How many items to return at one time
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InsurancesApi
     */
    public insuranceofficesGet(trashed?: number, offset?: number, size?: number, options?: AxiosRequestConfig) {
        return InsurancesApiFp(this.configuration).insuranceofficesGet(trashed, offset, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new insurance
     * @param {Company} [company] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InsurancesApi
     */
    public insuranceofficesPost(company?: Company, options?: AxiosRequestConfig) {
        return InsurancesApiFp(this.configuration).insuranceofficesPost(company, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all insurances
     * @param {number} [trashed] Get trashed items.
     * @param {number} [offset] How many items should be scipped. For example if you want to start at the third item, value should be 2.
     * @param {number} [size] How many items to return at one time
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InsurancesApi
     */
    public insurancesGet(trashed?: number, offset?: number, size?: number, options?: AxiosRequestConfig) {
        return InsurancesApiFp(this.configuration).insurancesGet(trashed, offset, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get a specific insurance
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InsurancesApi
     */
    public insurancesIdGet(id: number, options?: AxiosRequestConfig) {
        return InsurancesApiFp(this.configuration).insurancesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a specific insurance
     * @param {number} id 
     * @param {Company} [company] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InsurancesApi
     */
    public insurancesIdPut(id: number, company?: Company, options?: AxiosRequestConfig) {
        return InsurancesApiFp(this.configuration).insurancesIdPut(id, company, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new insurance
     * @param {Company} [company] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InsurancesApi
     */
    public insurancesPost(company?: Company, options?: AxiosRequestConfig) {
        return InsurancesApiFp(this.configuration).insurancesPost(company, options).then((request) => request(this.axios, this.basePath));
    }
}
